import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/wholesale-inventory",
    name: "Wholesale Inventory",
    component: () => import("./wholesaleInventoryPage.vue"),
  },
] satisfies RouteRecordRaw[];
